export const numberToFinnishString = (num: number): string => {
  const number = Math.round(num);
  return number.toLocaleString('fi-FI', {});
};
